import FilterCheckboxes from './FilterCheckboxes';
export default FilterCheckboxes;
